
import ExtElSelect from '../../extentions/el-select/el-select.vue';
import BbIcon from '../Icon/Icon.vue';
import { includesValidator } from '../../common/utils/validator';

const selectListSize = {
  Large: 'large',
  Small: 'small',
  ExtraSmall: 'mini',
};

export default {
  name: 'BbSelectList',
  components: { BbIcon, ExtElSelect },
  props: {
    hint: {
      type: String,
      default: '',
    },
    isAutocomplete: {
      type: Boolean,
      default: false,
    },
    isClearable: {
      type: Boolean,
      default: false,
    },
    isCustomInputMarkup: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isFilterable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: true,
    },
    isRemote: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: selectListSize.Large,
      validator: includesValidator(selectListSize),
    },
    label: {
      type: String,
      default: '',
    },
    loadingText: {
      type: String,
      default: 'Loading...',
    },
    noMatchText: {
      type: String,
      default: 'No data available',
    },
    noDataText: {
      type: String,
      default: 'No data available',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Array],
      default: '',
    },
    width: {
      type: String,
      default: '240px',
    },
    isAllowCreate: {
      type: Boolean,
      default: false,
    },
    remoteMethod: {
      type: Function,
      default: () => [],
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      query: '',
      optionsValues: [],
      cleared: false,
    };
  },
  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    classWrapper() {
      return ['bb-select-list', {
        empty: this.isNoSelection,
        'autocomplete-on': this.isAutocomplete,
        'search-autocomplete': this.isSearch,
        'is-clearable': this.isClearable && this.selectedItem,
        'custom-input-view': this.isCustomInputMarkup,
        error: this.hasError,
      }];
    },
    isClearButtonVisible() {
      const autocompleteWithValue = this.isAutocomplete && (this.query || this.selectedItem);
      const clearableWithValue = this.isClearable && this.selectedItem;

      return autocompleteWithValue || clearableWithValue;
    },
    isNoSelection() {
      return !this.selectedItem;
    },
    hasLabel() {
      return !!this.label;
    },
    isIconShown() {
      return this.isAutocomplete && this.isSearch;
    },
    attrs() {
      return {
        autocomplete: this.isAutocomplete ? 'on' : 'off',
        disabled: this.isDisabled,
        filterable: this.isAutocomplete || this.isFilterable,
        hint: this.hint,
        loading: this.isLoading,
        loadingText: this.loadingText,
        multiple: this.isAutocomplete ? false : this.isMultiple,
        noDataText: this.noDataText,
        noMatchText: this.noMatchText,
        placeholder: this.isAutocomplete
          ? this.placeholder
          || this.selectedItem
          || this.query
          || 'Search'
          : this.placeholder,
        popperAppendToBody: false,
        size: this.size,
        value: this.selectedItem,
        allowCreate: this.isAllowCreate,
        remote: this.isRemote,
        remoteMethod: this.remoteMethod,
        collapseTags: this.collapseTags,
      };
    },
  },
  methods: {
    clearSelection() {
      this.selectedItem = '';
      this.query = '';
      this.cleared = true;
      this.$emit('input-value-update', this.query);
    },
    updateQuery(event) {
      this.query = event.target.value;
      this.cleared = false;
      this.$emit('input-value-update', this.query);
      if (this.isRemote && !this.query) {
        this.selectedItem = '';
      }
    },
    selectAllHandler() {
      this.$refs.selectList.$slots.default.forEach((el) => {
        const { child } = el;
        if (child) {
          child.selected = false;
        }
      });
      this.selectedItem = [];
      this.query = '';
      this.$emit('input-value-update', this.query);
    },
  },

};
